import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { DealsListPage } from '@/features/deals';
import { workspaceSearchSchema } from '@/patterns';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/deals/')({
  validateSearch: workspaceSearchSchema.extend({
    stage: zSearchText(),
    bank: zSearchText(),
    product: zSearchText(),
    team: zSearchText(),
    sales: zSearchText(),
    mine: zSearchText(),
    stale: zSearchText(),
    pendingWith: zSearchText(),
    hold: zSearchText(),
    bucket: zSearchText(),
    period: zSearchText(),
    asAt: zSearchText(),
    cohort: zSearchText(),
    unit: zSearchText(),
    employment: zSearchText(),
    employer: zSearchText(),
    pendingWithMe: zSearchText(),
    mentions: zSearchText(),
  }),
  staticData: { crumb: 'nav.deals' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'deal.view', 'Deals'),
  component: function Deals() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <DealsListPage
        search={search}
        onSearchChange={(patch, o) =>
          void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false })
        }
      />
    );
  },
});
